<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue';
// ⚠️ 注意：如果 SmallBlock 和 MiddleBlock 不是全局注册的组件，你需要在这里手动导入它们
import SmallBlock from './components/SmallBlock.vue'
import MiddleBlock from './components/MiddleBlock.vue'
import './style.css';

// 1. Prepare Data
const data = ref<any[]>([]);
const menuItems = ref<string[]>([]);
const contentItems = ref<any[]>([]);
const activeIndex = ref<number>(0);

// 2. Core State & DOM References
const heightSumArr = ref<number[]>([]); 
const wrapperRef = ref<HTMLDivElement | null>(null);

// ✅ Fix: Initialize as a clean array to hold element references by index
const contentRefs = ref<HTMLDivElement[]>([]);

// ✅ Fix: Assign the element directly to its corresponding index
const setContentRef = (el: any, index: number) => {
  if (el) {
    contentRefs.value[index] = el as HTMLDivElement;
  }
};

// 3. Calculate Height Sum Array
const calculateHeights = async (): Promise<void> => {
  await nextTick();
  // Ensure styles and layout are fully painted
  await new Promise(resolve => setTimeout(resolve, 50));

  let currentSum = 0;
  heightSumArr.value = [];
  
  contentRefs.value.forEach((el) => {
    if (el) {
      currentSum += el.offsetHeight;
      heightSumArr.value.push(currentSum);
    }
  });
};

onMounted(async () => {
  try {
    const response = await fetch('/data.json');
    if (!response.ok) {
      throw new Error(`HTTP Error! Status: ${response.status}`);
    }
    
    data.value = await response.json();
    menuItems.value = data.value.map((item: any) => item.ctitle);

    contentItems.value = data.value.map((item: any) => ({
      titleOne: item.ctitle,
      titleTwo: item["items"] || [],
      mode: item["mode"]
    }));

    await nextTick();
    await calculateHeights();
  } catch (error) {
    console.error('Failed to load data:', error);
  }
});

// 4. Menu Click Scroll Handler
const handleMenuClick = (index: number): void => {
  activeIndex.value = index;

  if (!wrapperRef.value) return;

  if (index === 0) {
    wrapperRef.value.scrollTop = 0;
  } else {
    const targetScroll = heightSumArr.value[index - 1];
    if (targetScroll !== undefined) {
      wrapperRef.value.scrollTop = targetScroll;
    }
  }
};
</script>

<template>
  <div class="app-container">
    <div class="sidebar">
      <div class="menu-title">Arch Name.com</div>
      <div
        v-for="(item, index) in menuItems"
        :key="index"
        class="menu-item"
        :class="{ active: activeIndex === index }"
        @click="handleMenuClick(index)"
      >
        {{ item }}
      </div>
    </div>

    <div class="content-wrapper" ref="wrapperRef">
      <div
        v-for="(item, index) in contentItems"
        :key="index"
        class="content-block"
        :ref="(el) => setContentRef(el, index)"
      >
         <!-- <h2>{{ item }}</h2>
        <p>这是第 {{ index + 1 }} 个内容块。它的实际高度是 {{ (index + 1) * 150 }}px。</p>
        <p>当点击左侧对应菜单时，右侧会精准滚动到这里的顶部。</p> -->

        <div class="bottomRightContentHead">{{ item.titleOne }}</div>
        <div class="bottomRightContentBody">
          <hr style="border: 1px solid #eeeeee" />
          <el-row :gutter="24">
            <template v-for="(item2, index2) in item.titleTwo" :key="index2">
              <SmallBlock v-if="item.mode === 'small'" :obj="item2"></SmallBlock>
              <MiddleBlock v-else :obj="item2"></MiddleBlock>

              
              
            </template>
          </el-row>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Your existing styles remain perfectly fine */
.app-container {
  display: flex;
  height: 100vh;
  font-family: sans-serif;
}
.sidebar {
  width: 200px;
  background-color: #ccc;
  color: black;
  flex-shrink: 0;
  text-align: center;
}
.menu-title {
  padding: 20px;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #34495e;
}
.menu-item {
  padding: 15px 20px;
  cursor: pointer;
  transition: background 0.3s;
}
.menu-item:hover, .menu-item.active {
  background-color: #f1f4f9;
}
.menu-item.active {
  font-weight: bold;
}
.content-wrapper {
  flex: 1;
  height: 100vh; 
  overflow-y: auto; 
  padding: 20px;
  background-color: #ecf0f1;
  box-sizing: border-box;
}
.content-block {
  background-color: white;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  box-sizing: border-box;
}
.bottomRightContentHead {
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  text-align: left;
}
</style>